<script>
     Date.prototype.addDays = function(days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
    }


    import {apiUrl} from '../../../config.svelte';

    import {Button,Nav, NavItem, NavLink,Label,FormGroup,Input,CustomInput} from 'sveltestrap'
    import {onMount} from 'svelte'
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    export let activity={}
    onMount(()=>{
        loadFilterElemNames()
    })

    function loadFilterElemNames(){
        filter.elems=[]
        fetch(apiUrl+"ivm",{
            credentials: "include",
            method:"POST",
            body:JSON.stringify({method:"load-elem-names",activity:activity.activity}),
            cors:'no-cors'
        })
        .then(x=>x.json())
        .then(x=>{
            if(x.result){
                let elems=[]
                x.data.forEach(e=>{
                    elems.push({name:e.elemName,value:true})
                })
                filter.elems=elems
                filter=filter
            }

        })
        .catch((e)=>{
            console.log(e)
        })
    }

    let expanded = false
    let tab = "";

    let filter={
        date_from:(new Date()).addDays(-1).toJSON().substring(0,10),
        date_to:new Date().toJSON().substring(0,10),
        statuses:[
            {name:"Broken", value:true},
            {name:"Exception", value:true},
            {name:"no answer", value:true},
            {name:"Nothing", value:true},
            {name:"Transfer", value:true},
        ],
        elems:[],
        text:"",
        calllength:{
            min:0,
            max:900
        }
    }

    let search ={
        field:"",
        val:"",
    }

    function Apply(){
        dispatch('filterChanged',{filter:filter})
        expanded=false
    }
    function Search(){
        dispatch('search',{search:search})
        expanded=false
    }

</script>
{#if !expanded}
    <Button on:click={()=>{expanded=true}} outline color="dark" block style="text-align:left;float:left"><img src="/img/filter-ico2.png" alt="filter" style="width:20px;height:20px;"/>
        фильтры
    </Button>
{:else}
    <div style="postition:absolute;height:500px;border-radius:4px 4px 4px 4px;box-shadow: 0px 0px 2px black;width:calc(100% - 4px);margin:2px;">
        <Nav tabs>
            <NavItem>
                <NavLink  on:click={()=>{expanded=false}} style="color:black">Свернуть</NavLink>
            </NavItem>
            <NavItem>
                <NavLink active={tab=="поиск"?true:false} on:click={()=>{tab="поиск"}}>Поиск</NavLink>
            </NavItem>
            <NavItem>
                <NavLink active={tab=="даты"?true:false} on:click={()=>{tab="даты"}}>Даты</NavLink>
            </NavItem>
            <NavItem>
                <NavLink active={tab=="статусы"?true:false} on:click={()=>{tab="статусы"}}>Cтатусы</NavLink>
            </NavItem>
            <NavItem>
                <NavLink active={tab=="elemName"?true:false} on:click={()=>{tab="elemName"}}>elemName</NavLink>
            </NavItem>
            <NavItem>
                <NavLink active={tab=="речь"?true:false} on:click={()=>{tab="речь"}}>Речь</NavLink>
            </NavItem>
            <NavItem>
                <NavLink active={tab=="длительность"?true:false} on:click={()=>{tab="длительность"}}>Длительность</NavLink>
            </NavItem>
            <NavItem>
                <NavLink  on:click={()=>{Apply()}} style="color:black">Применить</NavLink>
            </NavItem>
        </Nav>
       <!-- <Button outline color="dark" style="position:absolute;right:148px;top:3px;" on:click={()=>{expanded=false;}}><img src="/img/min-box.png" style="width:20px;height:20px" alt="скрыть"/></Button>-->
        <div style="height:calc(100% - 40px);width:100%;box-shadow:0px 0px 1px black;overflow:auto">
            {#if tab=="поиск"}
                <div style="width:650px;margin-left:25px;">
                    <table>
                        <tr>
                            <td>
                                <Input type="select" bind:value={search.field}>
                                    <option value={undefined}>поле...</option>
                                    <option value={"xtelelink"}>xtelelink</option>
                                    <option value={"cardid"}>cardid</option>
                                    <option value={"callid"}>callid</option>
                                    <option value={"phone"}>phone</option>
                                </Input>
                            </td>
                            <td><Input type="text" bind:value={search.val}/></td>
                            <td><Button color="dark" on:click={()=>{Search()}}>поиск</Button></td>
                        </tr>
                    </table>
                </div>
            {:else if tab=="даты"}
                <div style="width:300px;margin-left:15px">
                    <div style="float:left">
                        <Label for="date-from-input" style="float:top">от</Label>
                        <Input type="date" id="date-from-input" style="float:left;width:200px;" bind:value={filter.date_from}/>
                    </div>
                    <div style="float:left">
                        <Label for="date-to-input" style="float:top">до</Label>
                        <Input type="date" id="date-to-input" style="float:left;width:200px;" bind:value={filter.date_to}/>
                    </div>
                </div>
            {:else if tab=="статусы"}
                <div style="width:650px;margin-left:25px;">
                    {#each filter.statuses as status}
                        <CustomInput type="checkbox" id={"Checkbox_"+status.name} label={status.name} bind:checked={status.value} />
                    {/each}
                </div>
            {:else if tab=="elemName"}
                 <div style="width:650px;margin-left:25px;">
                    {#each filter.elems as elem}
                        <CustomInput type="checkbox" id={"Checkbox_"+elem.name} label={elem.name} bind:checked={elem.value} />
                    {/each}
                </div>
            {:else if tab=="речь"}
                 <div style="width:650px;margin-left:25px;">
                    содержит<Input type="text" bind:value={filter.text} />
                </div>
            {:else if tab=="длительность"}
                 <div style="width:650px;margin-left:25px;">
                    от<input type="number" step="1" min="0" max="900" bind:value={filter.calllength.min}/>сек<br>
                    до<input type="number" step="1" min="0" max="900" bind:value={filter.calllength.max}/>сек
                </div>
            {/if}
        </div>
    </div>
{/if}
